<template>
  <InteractionWaiting v-if="!data"/>
  <InteractionStep v-else
                   :hasNext="false">
    <template v-slot:content>
      <transition name="fade">
        <div v-if="data.download_all"
             class="interaction-step__download-wrap">
          <a href="#"
             @click.prevent="downloadByOneArchive"
             class="interaction-step__download  base-btn base-btn--outline-dark">
            <BaseSvg name="ico-download-2"
                     width="1.4rem"
                     height="1.4rem"/>
            <span>{{ $tInteraction('Download by one archive') }}</span>
          </a>
        </div>
        <div v-if="false"
             class="preloader-circles" style="position: static">
          <svg xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 128 128"
               xml:space="preserve">
              <g>
                <circle cx="16"
                        cy="64"
                        r="16"
                />
                <circle cx="16"
                        cy="64"
                        r="14.344"
                        transform="rotate(45 64 64)"/>
                <circle
                  cx="16"
                  cy="64"
                  r="12.531"
                  transform="rotate(90 64 64)"/>
                <circle cx="16"
                        cy="64"
                        r="10.75"
                        transform="rotate(135 64 64)"/>
                <circle
                  cx="16"
                  cy="64"
                  r="10.063"
                  transform="rotate(180 64 64)"/>
                <circle cx="16"
                        cy="64"
                        r="8.063"
                        transform="rotate(225 64 64)"/>
                <circle
                  cx="16"
                  cy="64"
                  r="6.438"
                  transform="rotate(270 64 64)"/>
                <circle cx="16"
                        cy="64"
                        r="5.375"
                        transform="rotate(315 64 64)"/>
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
                  calcMode="discrete"
                  dur="720ms"
                  repeatCount="indefinite"></animateTransform>
              </g>
            </svg>

          <div class="preloader-circles__text">{{ waitingText }}...</div>
        </div>
        <div v-if="false"
             class="interaction-waiting" style="position: static">
          <div class="interaction-waiting__loader"></div>
          <div class="interaction-waiting__text">{{ waitingText }}...</div>
        </div>
      </transition>
      <div class="step-text">
        <div v-if="description"
             v-html="description"
             class="step-text__text text">
        </div>
        <div class="step-text__text text" style="font-size: 1.5rem">
          <p>{{ $tInteraction('Days to arrival') }}: <b>{{ daysToArrival }}
            {{ $tInteraction('days', +daysToArrival) }}</b></p>
          <p>{{ $tInteraction('You will arrive') }}
            <!--            <template v-if="address">{{ $tInteraction('at') }}</template>-->
            {{ address }} {{ dateString }}
            <template v-if="timeString">{{ $tInteraction('to') }}</template>
            {{ timeString }}
          </p>
        </div>
      </div>

      <div v-if="downloadChecklistLink"
           style="margin: 2rem 0 2rem; text-align: center"
           class="step-text">
        <h3 class="step-text__title">
          {{ $tInteraction('Download Checklist') }}
        </h3>
        <a :href="downloadChecklistLink"
           target="_blank"

           class="base-btn  base-btn--outline-dark">
          <span class="_one">{{ $tInteraction('Download') }}</span>
          <BaseSvg name="ico-download-2"
                   width="1.4rem"
                   height="1.4rem"/>
        </a>
      </div>

      <template v-if="data.ticket && data.ticket.length">
        <div class="step-text" style="margin-bottom: 2rem">
          <h3 class="step-text__title">{{ $tInteraction('Your ticket') }}</h3>
        </div>
        <div class="step-check-files__list">
          <div v-for="(file, index) in  data.ticket"
               :key="file.file.id"
               class="step-check-files__item  _not_grow">
            <div class="step-check-files__item-file-wrap">
              <FileShow :value="file.file"
                        class="step-check-files__item-file-el"/>
            </div>
            <!--            <div v-else class="step-check-files__item-file-wrap">-->
            <!--              <FileShow :value="file.file"-->
            <!--                        class="step-check-files__item-file-el"/>-->
            <!--            </div>-->
            <div class="step-check-files__item-buttons">
              <a :href="file.file.path"
                 download

                 @click.prevent="onDownload(file.file)"
                 class="base-btn step-check-files__item-btn _download"
              >
                <span class="_one">{{ $tInteraction('Download') }}</span>
                <BaseSvg name="ico-download-2"
                         width="1.4rem"
                         height="1.4rem"/>
              </a>
              <button v-if="isFileImg(file.file)"
                      @click="openTickerGallery(index)"
                      class="base-btn step-check-files__item-btn _see"
              >
                <span class="_one">{{ $tInteraction('View') }}</span>
                <BaseSvg name="ico-see"
                         width="1.4rem"
                         height="1.4rem"/>
              </button>
            </div>
          </div>
        </div>
      </template>

      <template v-if="data.insurance && data.insurance.length">
        <div class="step-text" style="margin-bottom: 2rem">
          <h3 class="step-text__title">{{ $tInteraction('Your insurance') }}</h3>
        </div>
        <div class="step-check-files__list">
          <div v-for="(file, index) in  data.insurance"
               :key="file.file.id"
               class="step-check-files__item  _not_grow">
            <div class="step-check-files__item-file-wrap">
              <FileShow :value="file.file"
                        class="step-check-files__item-file-el"/>
            </div>
            <!--            <div v-else class="step-check-files__item-file-wrap">-->
            <!--              <FileShow :value="file.file"-->
            <!--                        class="step-check-files__item-file-el"/>-->
            <!--            </div>-->
            <div class="step-check-files__item-buttons">
              <a :href="file.file.path"
                 download

                 @click.prevent="onDownload(file.file)"
                 class="base-btn step-check-files__item-btn _download"
              >
                <span class="_one">{{ $tInteraction('Download') }}</span>
                <BaseSvg name="ico-download-2"
                         width="1.4rem"
                         height="1.4rem"/>
              </a>
              <button v-if="isFileImg(file.file)"
                      @click="openInsuranceGallery(index)"
                      class="base-btn step-check-files__item-btn _see"
              >
                <span class="_one">{{ $tInteraction('View') }}</span>
                <BaseSvg name="ico-see"
                         width="1.4rem"
                         height="1.4rem"/>
              </button>
            </div>
          </div>
        </div>
      </template>

      <template v-if="data.invitation && data.invitation.length">
        <div class="step-text" style="margin-bottom: 2rem">
          <h3 class="step-text__title">{{ $tInteraction('Your invitation and letter') }}</h3>
        </div>
        <div class="step-check-files__list">
          <div v-for="(file, index) in  data.invitation"
               :key="file.file.id"
               class="step-check-files__item  _not_grow">
            <div class="step-check-files__item-file-wrap">
              <FileShow :value="file.file"
                        class="step-check-files__item-file-el"/>
            </div>
            <!--            <div v-else class="step-check-files__item-file-wrap">-->
            <!--              <FileShow :value="file.file"-->
            <!--                        class="step-check-files__item-file-el"/>-->
            <!--            </div>-->
            <div class="step-check-files__item-buttons">
              <a :href="file.file.path"
                 download

                 @click.prevent="onDownload(file.file)"
                 class="base-btn step-check-files__item-btn _download"
              >
                <span class="_one">{{ $tInteraction('Download') }}</span>
                <BaseSvg name="ico-download-2"
                         width="1.4rem"
                         height="1.4rem"/>
              </a>
              <button v-if="isFileImg(file.file)"
                      @click="openInvitationGallery(index)"
                      class="base-btn step-check-files__item-btn _see"
              >
                <span class="_one">{{ $tInteraction('View') }}</span>
                <BaseSvg name="ico-see"
                         width="1.4rem"
                         height="1.4rem"/>
              </button>
            </div>
          </div>
        </div>
      </template>

      <div class="step-text" style="margin-top: 3rem">
        <div class="step-text__text text" style="font-size: 1.5rem">
          <p>{{ $tInteraction('invitation_is_ready_text') }}</p>
        </div>
      </div>


      <div class="step-text" style="margin-top: 3rem">
        <h3 class="step-text__title">
          {{ $tInteraction('app_title') }}
        </h3>
        <div class="step-text__text text">
          <p>{{ $tInteraction('app_text') }}</p>
        </div>
        <a target="_blank"
           href="https://play.google.com/store/apps/details?id=com.ua.jobian"
           class="interaction-step__app-link">
          <img src="../../../assets/img/google-play-logo.png"
               alt="google-play-app">
        </a>
      </div>


      <CoolLightBox v-if="ticketFiles && ticketFiles.length"
                    :items="ticketFiles"
                    :index="ticketGalleryIndex"
                    @close="insuranceGalleryIndex = null"/>

      <CoolLightBox v-if="insuranceFiles && insuranceFiles.length"
                    :items="insuranceFiles"
                    :index="insuranceGalleryIndex"
                    @close="insuranceGalleryIndex = null"/>
      <CoolLightBox v-if="invitationFiles && invitationFiles.length"
                    :items="invitationFiles"
                    :index="invitationGalleryIndex"
                    @close="invitationGalleryIndex = null"/>

    </template>
  </InteractionStep>
</template>

<script>
  import {mapState} from 'vuex'
  import getDaysBetween from '../../../helpers/getDaysBetween'
  import InteractionStep from '../InteractionStep'
  import InteractionWaiting from '../InteractionWaiting'
  import FileShow from '../../FileShow'
  import {ALLOWED_IMAGES_EXTS, IMAGES_MIME_TYPES} from "../../../constants/files"
  import download from "../../../helpers/download"
  import parseDateForLocal from "../../../helpers/parseDateForLocal"
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  const CoolLightBox = () => import(/* webpackChunkName: "light-box" */ '../../../components/CoolLightBox')

  let timer

  export default {
    mixins: [interactionStepMixin],
    components: {
      InteractionStep,
      InteractionWaiting,
      FileShow,
      CoolLightBox
    },
    data() {
      return {
        data: null,
        title: null,
        description: null,
        ticketGalleryIndex: null,
        insuranceGalleryIndex: null,
        invitationGalleryIndex: null,
        currentTime: new Date()
      }
    },
    computed: {
      ...mapState('interaction', [
        'waitingText',
      ]),
      date() {
        if (!this.arrival_info) return
        return parseDateForLocal(this.data.arrival_info.data)
        // d.setHours(this.arrival_info.time_hours)
        // d.setMinutes(this.arrival_info.time_minutes)
        // return d
      },
      dateString() {
        const date = this.date
        if (!date) return

        return this.date.toLocaleDateString()
      },
      timeString() {
        const date = this.date
        if (!date) return
        return date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
      },
      address() {
        const a = [this.data.arrival_info.city, this.data.arrival_info.street_name, this.data.arrival_info.street_number]
        return a.filter(a => a).join(', ')
      },
      daysToArrival() {
        const arrivalDate = parseDateForLocal(this.data.arrival_info.data)
        const days = getDaysBetween(this.currentTime, arrivalDate)
        return days < 0 ? 0 : days
      },
      ticketFiles() {
        return this.data.insurance.map(file => file.file.path)
      },
      insuranceFiles() {
        return this.data.insurance.map(file => file.file.path)
      },
      invitationFiles() {
        return this.data.invitation.map(file => file.file.path)
      },
      token() {
        return this.$store.state.user.token
      },
      downloadChecklistLink() {
        if (!this.data.check_list_link) return

        return this.data.check_list_link + `?token=${this.token}`
      }
    },
    methods: {
      isFileImg(file) {
        if (file.type) {
          return IMAGES_MIME_TYPES.includes(file.type.toLowerCase())
        } else if (file.ext) {
          return ALLOWED_IMAGES_EXTS.includes(file.ext.toLowerCase())
        }
      },
      onDownload(file) {
        download(file.path, file.name_for_download || file.name, file.name_for_download ? null : file.ext)
      },
      downloadByOneArchive() {
        download(this.data.download_all.link, this.data.download_all.name)
      },
      openTickerGallery(index) {
        this.ticketGalleryIndex = index
      },
      openInsuranceGallery(index) {
        this.insuranceGalleryIndex = index
      },
      openInvitationGallery(index) {
        this.invitationGalleryIndex = index
      }
    },
    created() {
      const data = this.$store.state.interaction.stepData
      this.data = data.data && data.data.arrival_info ? data.data : null
      this.title = data.title
      this.description = data.description

      timer = setInterval(() => {
        this.currentTime = new Date()
      }, 10000)
    },
    beforeDestroy() {
      clearInterval(timer)
    }
  }
</script>

<style lang="less">

</style>
